import { render } from "./SkillGroupView.vue?vue&type=template&id=2a9ecdd4&scoped=true&ts=true"
import script from "./SkillGroupView.vue?vue&type=script&lang=ts"
export * from "./SkillGroupView.vue?vue&type=script&lang=ts"

import "./SkillGroupView.vue?vue&type=style&index=0&id=2a9ecdd4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9ecdd4"]])

export default __exports__